import React, {useRef} from 'react';
import {BottomSheet} from "react-spring-bottom-sheet";
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {themecolors} from "../../utils/themecolors";
import {useStoreProfile} from "../../store"

export const Header = styled.div``;
export const Button = styled.div``;
export const Title = styled.h2``;
export const MenuItem = styled.div``;
export const MenuItemIcon = styled.div``;
export const MenuItemText = styled.div``;
export const Footer = styled.div``;

const Sheet = styled(({className, padding, onClose, isMaxHeight, canMaxHeight, animate = true, children}) => {

    const {theme} = useStoreProfile();
    const sheetRef = useRef(null);

    const handleMaxHeight = () => {
        sheetRef.current.snapTo(({ maxHeight }) => maxHeight)
    };

    const handleClick = (event) => {
        event.stopPropagation();
    };

    return (
        <div style={{backgroundColor: 'red', height: '100vh', position: 'fixed'}}>
            <BottomSheet open={open}
                         onClick={handleClick}
                         ref={sheetRef}
                         skipInitialTransition
                         initialFocusRef
                         snapPoints={({ minHeight, maxHeight }) => isMaxHeight ? [maxHeight] : canMaxHeight ? [minHeight, maxHeight] : [minHeight]}
                         sibling={
                <div
                    data-rsbs-backdrop="true"
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        onClose && onClose();
                    }}
                />
            }
                         blocking={false}
                         className={`${className} ${theme === 'dark' ? 'dark-menu' : 'light-menu'}`}
                         onDismiss={onClose}>
                <SheetInner padding={padding} handleMaxHeight={handleMaxHeight}>{children}</SheetInner>
            </BottomSheet>
        </div>
    );
})`
  &.dark-menu {
    --rsbs-bg: ${themecolors.dark_background_1};
    --rsbs-handle-bg: ${themecolors.dark_background_6};
  }
`;

const SheetInner = styled(({className, padding = "menu", handleMaxHeight, children}) => {

    const paddingType = {
        "header": "4px 28px 28px 28px",
        "menu": "4px 16px 32px 16px",
        "input": "0 12px 16px 12px",
    }


    return (
        <div style={{padding: paddingType[padding]}} className={className}>
            {React.cloneElement(children, { handleMaxHeight })}
        </div>
    );
})`
  ${Header} {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  
  ${Footer} {
    display: flex;
    align-items: center;
    padding-top: 4px;
  }

  ${Button} {
    margin-left: auto;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : '#dfdfdf'};
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
    border-radius: 48px;
    padding: 4px 16px;
    font-size: 17px;
    font-weight: 500;
  }

  ${Title} {
    font-size: 20px !important;
    font-weight: 600 !important;
    margin: 0 !important;
  }

  ${MenuItem} {
    display: flex;
    padding: 12px 16px;
    margin-bottom: 6px;
    border-radius: 4px;
    align-items: center;
  }

  ${MenuItem}:last-of-type {
    margin-bottom: 0;
  }

  ${MenuItem}:active {
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : 'rgba(0,0,0,.06)'};
  }
  ${MenuItemIcon} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    margin-right: 16px;
  }

  ${MenuItemText} {
    font-size: 16px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
    font-weight: 500;
  }
`;

export default Sheet;
